/* ==========================================================================
   Accessibility Widget — Wertheim Center
   Persists settings via localStorage. Keyboard-friendly.
   ========================================================================== */
(function () {
  'use strict';

  var STORAGE_KEY = 'wertheim_a11y_v2';
  var html = document.documentElement;

  var defaultState = {
    fontSize: 0,            // 0 = רגיל, 1 = גדול, 2 = גדול יותר
    letterSpacing: false,
    lineHeight: false,
    highlightLinks: false,
    highlightHeadings: false,
    readableFont: false,
    noMotion: false,
    contrast: '',           // '' | 'mono' | 'dark' | 'light'
    grayscale: false,
    invert: false,
    bigCursor: false,
    readingGuide: false
  };

  var state = loadState();

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return Object.assign({}, defaultState);
      return Object.assign({}, defaultState, JSON.parse(raw));
    } catch (e) {
      return Object.assign({}, defaultState);
    }
  }

  function saveState() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); } catch (e) {}
  }

  function applyState() {
    var body = document.body;

    // Font size — text-only scaling (NOT page zoom). See applyFontScale.
    if (state.fontSize === 0) {
      html.removeAttribute('data-a11y-font-size');
    } else {
      html.setAttribute('data-a11y-font-size', String(state.fontSize));
    }
    applyFontScale(state.fontSize);

    // Boolean classes
    var classMap = {
      'a11y-letter-spacing':   state.letterSpacing,
      'a11y-line-height':      state.lineHeight,
      'a11y-links':            state.highlightLinks,
      'a11y-headings':         state.highlightHeadings,
      'a11y-readable-font':    state.readableFont,
      'a11y-no-motion':        state.noMotion,
      'a11y-grayscale':        state.grayscale,
      'a11y-invert':           state.invert,
      'a11y-big-cursor':       state.bigCursor,
      'a11y-reading-guide-on': state.readingGuide
    };
    Object.keys(classMap).forEach(function (cls) {
      body.classList.toggle(cls, !!classMap[cls]);
    });

    // Stop JS-driven carousel autoplay when motion is paused (CSS can't reach it).
    if (state.noMotion) stopAutoMotion();

    // Contrast mode (exclusive)
    body.classList.remove('a11y-mono', 'a11y-dark', 'a11y-light');
    if (state.contrast === 'mono') body.classList.add('a11y-mono');
    if (state.contrast === 'dark') body.classList.add('a11y-dark');
    if (state.contrast === 'light') body.classList.add('a11y-light');

    syncButtons();
  }

  // Enlarge TEXT only — never the page layout, images, or the widget.
  // The theme uses fixed-px type, so we read each element's real rendered
  // font-size once, cache it, and rescale from that cached base. Already-large
  // headings are dampened so they grow gently instead of breaking the layout.
  var FONT_FACTORS = [1, 1.18, 1.4];   // רגיל / גדול / גדול יותר
  function a11ySkipFont(el) {
    // Elements we must not touch at all (no text, or part of the widget UI).
    var tag = el.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'PATH' ||
        tag === 'BR' || tag === 'HR' || tag === 'LINK' || tag === 'META' ||
        tag === 'SOURCE' || tag === 'TRACK') return true;
    if (el.closest && el.closest('.a11y-panel, .a11y-trigger, .a11y-reading-guide, .wa-fab, .scroll__top')) return true;
    return false;
  }
  function a11yIsMedia(tag) {
    // Replaced/media elements: many icons are sized in `em` (width:1em) and would
    // blow up because font-size inherits. We PIN their font-size to base so they
    // keep their size while surrounding text grows.
    return tag === 'IMG' || tag === 'SVG' || tag === 'PICTURE' || tag === 'VIDEO' ||
           tag === 'CANVAS' || tag === 'IFRAME' || tag === 'OBJECT' || tag === 'EMBED';
  }
  function applyFontScale(level) {
    var factor = FONT_FACTORS[level] || 1;
    var nodes = document.body ? document.body.querySelectorAll('*') : [];
    var i, el, base;
    // Pass 1: cache each element's true base size + original inline value (once).
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      if (el.__a11yBaseFont != null || a11ySkipFont(el)) continue;
      el.__a11yOrigInline = el.style.fontSize || '';
      el.__a11yBaseFont = parseFloat(window.getComputedStyle(el).fontSize) || 0;
    }
    // Pass 2: apply (or restore on level 0).
    for (i = 0; i < nodes.length; i++) {
      el = nodes[i];
      base = el.__a11yBaseFont;
      if (base == null) continue;
      if (level === 0) { el.style.fontSize = el.__a11yOrigInline || ''; continue; }
      if (a11yIsMedia(el.tagName)) { el.style.fontSize = base + 'px'; continue; } // pin: no em blow-up
      var grow = base * (factor - 1);
      if (base > 40) grow *= 0.18;        // already-huge display titles barely move
      else if (base > 28) grow *= 0.5;    // big headings grow gently
      el.style.fontSize = (base + grow).toFixed(2) + 'px';
    }
  }

  // Pause Flickity carousel autoplay — Flickity's player is a JS timer, not a CSS
  // animation, so `body.a11y-no-motion` (CSS) can't stop it on its own.
  function stopAutoMotion() {
    try {
      if (window.jQuery) {
        window.jQuery('.flickity-enabled').each(function () {
          try { window.jQuery(this).flickity('stopPlayer'); } catch (e) {}
        });
      }
    } catch (e) {}
  }

  function t(key, fallback) {
    var labels = window.WertheimA11yLabels || {};
    return labels[key] || fallback;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c];
    });
  }

  function buildWidget() {
    if (document.querySelector('.a11y-trigger')) return;

    var trigger = document.createElement('button');
    trigger.className = 'a11y-trigger';
    trigger.type = 'button';
    trigger.setAttribute('aria-label', t('open', 'פתיחת תפריט נגישות'));
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', 'wertheim-a11y-panel');
    trigger.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true">'
      + '<circle cx="12" cy="3.5" r="1.5"/>'
      + '<path d="M20 7.5l-6 1v3.5l1.5 8.5h-2L12 14l-1.5 6.5h-2L10 12V8.5L4 7.5l.3-1.6 5.7.7h4l5.7-.7z"/>'
      + '</svg>';

    var panel = document.createElement('div');
    panel.className = 'a11y-panel';
    panel.id = 'wertheim-a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'false');
    panel.setAttribute('aria-labelledby', 'wertheim-a11y-title');
    panel.setAttribute('aria-hidden', 'true');

    var title          = escapeHtml(t('title',           'תפריט נגישות'));
    var closeLabel     = escapeHtml(t('close',           'סגירה'));
    var grpText        = escapeHtml(t('text',            'גודל טקסט'));
    var grpReading     = escapeHtml(t('reading',         'קריאה'));
    var grpColor       = escapeHtml(t('color',           'צבעים וניגודיות'));
    var grpNav         = escapeHtml(t('navigation',      'ניווט והתמצאות'));
    var fontRegular    = escapeHtml(t('font_regular',    'רגיל'));
    var fontLarge      = escapeHtml(t('font_large',      'גדול'));
    var fontLarger     = escapeHtml(t('font_larger',     'גדול יותר'));
    var letterSpacing  = escapeHtml(t('letter_spacing',  'ריווח אותיות'));
    var lineHeight     = escapeHtml(t('line_height',     'ריווח שורות'));
    var readableFont   = escapeHtml(t('readable_font',   'גופן קריא'));
    var highlightLinks = escapeHtml(t('highlight_links', 'הדגשת קישורים'));
    var highlightHead  = escapeHtml(t('highlight_headings','הדגשת כותרות'));
    var readingGuide   = escapeHtml(t('reading_guide',   'סרגל קריאה'));
    var monoLabel      = escapeHtml(t('contrast_mono',   'שחור־לבן'));
    var darkLabel      = escapeHtml(t('contrast_dark',   'חדות כהה'));
    var lightLabel     = escapeHtml(t('contrast_light',  'חדות בהירה'));
    var grayscale      = escapeHtml(t('grayscale',       'גווני אפור'));
    var invert         = escapeHtml(t('invert',          'היפוך צבעים'));
    var bigCursor      = escapeHtml(t('big_cursor',      'סמן מוגדל'));
    var noMotion       = escapeHtml(t('no_motion',       'עצירת אנימציות'));
    var reset          = escapeHtml(t('reset',           'איפוס הגדרות'));
    var statementLink  = escapeHtml(t('statement_link',  'הצהרת נגישות מלאה'));
    var statementUrl   = (window.WertheimA11yStatementUrl || '/pages/accessibility-statement');

    panel.innerHTML = [
      '<div class="a11y-panel__header">',
        '<h2 class="a11y-panel__title" id="wertheim-a11y-title">' + title + '</h2>',
        '<button class="a11y-panel__close" type="button" aria-label="' + closeLabel + '">',
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>',
        '</button>',
      '</div>',
      '<div class="a11y-panel__body">',

        '<div class="a11y-group">',
          '<h3 class="a11y-group__title">' + grpText + '</h3>',
          '<div class="a11y-options a11y-options--three">',
            '<button type="button" class="a11y-option a11y-option--font" data-fontsize="0">',
              '<span class="a11y-option__sample" aria-hidden="true">א</span>',
              '<span class="a11y-option__label">' + fontRegular + '</span>',
            '</button>',
            '<button type="button" class="a11y-option a11y-option--font" data-fontsize="1">',
              '<span class="a11y-option__sample" aria-hidden="true">א</span>',
              '<span class="a11y-option__label">' + fontLarge + '</span>',
            '</button>',
            '<button type="button" class="a11y-option a11y-option--font" data-fontsize="2">',
              '<span class="a11y-option__sample" aria-hidden="true">א</span>',
              '<span class="a11y-option__label">' + fontLarger + '</span>',
            '</button>',
          '</div>',
          '<div class="a11y-options" style="margin-top:8px">',
            '<button type="button" class="a11y-option" data-toggle="letterSpacing">' + letterSpacing + '</button>',
            '<button type="button" class="a11y-option" data-toggle="lineHeight">' + lineHeight + '</button>',
          '</div>',
        '</div>',

        '<div class="a11y-group">',
          '<h3 class="a11y-group__title">' + grpReading + '</h3>',
          '<div class="a11y-options">',
            '<button type="button" class="a11y-option" data-toggle="readableFont">' + readableFont + '</button>',
            '<button type="button" class="a11y-option" data-toggle="highlightLinks">' + highlightLinks + '</button>',
            '<button type="button" class="a11y-option" data-toggle="highlightHeadings">' + highlightHead + '</button>',
            '<button type="button" class="a11y-option" data-toggle="readingGuide">' + readingGuide + '</button>',
          '</div>',
        '</div>',

        '<div class="a11y-group">',
          '<h3 class="a11y-group__title">' + grpColor + '</h3>',
          '<div class="a11y-options">',
            '<button type="button" class="a11y-option" data-contrast="mono">' + monoLabel + '</button>',
            '<button type="button" class="a11y-option" data-contrast="dark">' + darkLabel + '</button>',
            '<button type="button" class="a11y-option" data-contrast="light">' + lightLabel + '</button>',
            '<button type="button" class="a11y-option" data-toggle="grayscale">' + grayscale + '</button>',
            '<button type="button" class="a11y-option" data-toggle="invert">' + invert + '</button>',
          '</div>',
        '</div>',

        '<div class="a11y-group">',
          '<h3 class="a11y-group__title">' + grpNav + '</h3>',
          '<div class="a11y-options">',
            '<button type="button" class="a11y-option" data-toggle="bigCursor">' + bigCursor + '</button>',
            '<button type="button" class="a11y-option" data-toggle="noMotion">' + noMotion + '</button>',
          '</div>',
        '</div>',

        '<div class="a11y-group">',
          '<button type="button" class="a11y-reset">' + reset + '</button>',
        '</div>',
      '</div>',

      '<div class="a11y-panel__footer">',
        '<a href="' + statementUrl + '">' + statementLink + '</a>',
      '</div>'
    ].join('');

    var guide = document.createElement('div');
    guide.className = 'a11y-reading-guide';
    guide.setAttribute('aria-hidden', 'true');

    document.body.appendChild(trigger);
    document.body.appendChild(panel);
    document.body.appendChild(guide);

    bindEvents(trigger, panel, guide);
  }

  function bindEvents(trigger, panel, guide) {
    var closeBtn = panel.querySelector('.a11y-panel__close');
    var resetBtn = panel.querySelector('.a11y-reset');

    function open() {
      panel.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      var firstFocusable = panel.querySelector('button, [href]');
      if (firstFocusable) firstFocusable.focus();
    }
    function close() {
      panel.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }

    trigger.addEventListener('click', function () {
      var isOpen = panel.getAttribute('aria-hidden') === 'false';
      isOpen ? close() : open();
    });

    closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      var isOpen = panel.getAttribute('aria-hidden') === 'false';
      if (!isOpen) return;
      if (panel.contains(e.target) || trigger.contains(e.target)) return;
      close();
    });

    panel.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn || btn === closeBtn || btn === resetBtn) return;

      var toggle  = btn.getAttribute('data-toggle');
      var contrast = btn.getAttribute('data-contrast');
      var fontsize = btn.getAttribute('data-fontsize');

      if (toggle && state.hasOwnProperty(toggle)) {
        state[toggle] = !state[toggle];
      } else if (contrast !== null) {
        // Click again on the active mode → turn off
        state.contrast = (state.contrast === contrast) ? '' : contrast;
      } else if (fontsize !== null) {
        state.fontSize = parseInt(fontsize, 10);
      } else {
        return;
      }

      saveState();
      applyState();
    });

    resetBtn.addEventListener('click', function () {
      state = Object.assign({}, defaultState);
      saveState();
      applyState();
    });

    document.addEventListener('mousemove', function (e) {
      if (!state.readingGuide) return;
      guide.style.top = e.clientY + 'px';
    });
  }

  function syncButtons() {
    var panel = document.querySelector('.a11y-panel');
    if (!panel) return;

    panel.querySelectorAll('[data-toggle]').forEach(function (btn) {
      var key = btn.getAttribute('data-toggle');
      btn.setAttribute('aria-pressed', state[key] ? 'true' : 'false');
    });

    panel.querySelectorAll('[data-contrast]').forEach(function (btn) {
      var key = btn.getAttribute('data-contrast');
      btn.setAttribute('aria-pressed', state.contrast === key ? 'true' : 'false');
    });

    panel.querySelectorAll('[data-fontsize]').forEach(function (btn) {
      var key = parseInt(btn.getAttribute('data-fontsize'), 10);
      btn.setAttribute('aria-pressed', state.fontSize === key ? 'true' : 'false');
    });
  }

  function init() {
    buildWidget();
    applyState();

    // Carousels are initialised by the theme after this runs, so re-pause them
    // once everything has loaded if the user keeps motion paused.
    if (state.noMotion) {
      window.addEventListener('load', function () {
        stopAutoMotion();
        setTimeout(stopAutoMotion, 1200);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
